import { DEFAULT_PROFILE_SAMPLING_LAYERS } from '../services/elevationService';
export const COLOR_BY_OPTIONS = [
    { value: 'elevation', label: 'Elevation', sampled: false },
    { value: 'slope_grade', label: 'Slope (path grade)', sampled: false },
    { value: 'slope', label: 'Slope (terrain)', sampled: true },
    { value: 'aspect', label: 'Aspect', sampled: true },
    { value: 'geomorphons', label: 'Geomorphons', sampled: true },
    { value: 'twi', label: 'Wetness (TWI)', sampled: true },
    { value: 'flow_accumulation', label: 'Flow Accumulation', sampled: true },
];
// The sampling layers that are ready to read right now. Used to filter the
// draw-time profile fetch so a still-writing COG is never opened — opening one
// poisons the per-project GDAL handle cache until the web-server reloads.
// Undefined state (no status info) means "treat everything as ready".
export const readyAnalyticalLayers = (state) => {
    if (!state)
        return [...DEFAULT_PROFILE_SAMPLING_LAYERS];
    return DEFAULT_PROFILE_SAMPLING_LAYERS.filter(layer => !state[layer]);
};
// Resolves each option to its display label + disabled state for the current
// readiness. Not-ready sampled options are disabled and suffixed so the user
// sees why the colour isn't selectable yet.
export const colorByOptionViews = (state) => COLOR_BY_OPTIONS.map(opt => {
    const status = opt.sampled ? state === null || state === void 0 ? void 0 : state[opt.value] : undefined;
    if (status === 'processing') {
        return { value: opt.value, label: `${opt.label} (still processing)`, disabled: true };
    }
    if (status === 'failed') {
        return { value: opt.value, label: `${opt.label} (currently unavailable)`, disabled: true };
    }
    return { value: opt.value, label: opt.label, disabled: false };
});
